var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-content-composer-options-auto-complete"},[_c('form-input',{attrs:{"type":"number","min-value":"1","step":"1","label":_vm.$t('form_content_composer.options_input.label.maxRepeats'),"value":_vm.value.maxRepeats,"required":true},on:{"input":function($event){return _vm.onInput('maxRepeats', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }